import { isProjectWidgetMode, PRIVATE_ROOT_ROUTE } from '../routes'

/** Build redux payload when URL is a widget embed link. */
export const buildWidgetRedirectFromLocation = (pathname, search = '') => {
    if (!isProjectWidgetMode(search)) return null
    if (!pathname?.startsWith(PRIVATE_ROOT_ROUTE)) return null
    return {
        pathname,
        search: search || '',
    }
}

export const getNavigateTargetFromWidgetRedirect = (redirect) => {
    if (!redirect?.pathname) return null
    return {
        pathname: redirect.pathname,
        search: redirect.search || '',
    }
}
